import React, { useEffect, useRef, useState } from 'react';
import { InstantSearch, Configure } from 'react-instantsearch';
import aa from 'search-insights';

import CustomSearchBox from './CustomSearchBox';
import CustomMenuSelectDivision from './CustomMenuSelectDivision';
import CustomMenuSelect from './CustomMenuSelect';
import CustomInfiniteHits from './CustomInfiniteHits';
import CustomPriceRange from './CustomPriceRange';
import CustomHierarchicalMenu from './CustomHierarchicalMenu';
import CustomToggle from './CustomToggle';
import CustomClearRefinements from './CustomClearRefinements';
import CustomBreadcrumb from './CustomBreadcrumb';
import { useSize } from '../../hooks/useSize';
import SearchLayout, { SIDEBAR_MIN_WIDTH } from '../product-search/shared/SearchLayout';
import { min } from 'lodash';
import { searchClient, indexName } from './Algoliasearch';
import { useHasUserFlag } from '../../hooks';

const itemsPerPage = 40;

const ProductSuggestionSearch = ({ order, full_order, loading, onAddItem, onDeleteItem, divisions, suggestion, setSuggestion, tenantId, isProductsPage }) => {
  const userToken = tenantId;
  const [range, setRange] = useState({ min: '', max: '' });
  const menuRef = useRef(null);
  const [, setIsShowMore] = useState(false); //force re-render when show more is clicked
  const productSuggestionsDisabled = useHasUserFlag('PRODUCT-SUGGESTIONS-DISABLED');
  useEffect(() => {
    if (userToken && !productSuggestionsDisabled) {
      aa('setUserToken', userToken);
    }
  }, [userToken, productSuggestionsDisabled]);
  const [ref, size] = useSize();

  const sidebarTop = min([0, ref.current?.clientHeight - menuRef.current?.clientHeight - 20]);

  return (
    <InstantSearch
      searchClient={searchClient} indexName={indexName} future={{ preserveSharedStateOnUnmount: true }} insights={!productSuggestionsDisabled} >
      <SearchLayout
        containerRef={ref}
        sidebarRef={menuRef}
        sidebarTop={sidebarTop}
        isProductsPage={isProductsPage}
        sidebar={
          <>
            <CustomMenuSelectDivision
              label="Supplier"
              divisions={divisions}
            />
            <CustomMenuSelect attribute='product_brand' label="Brand" limit={100} />
            <CustomToggle attribute='currency' defaultLabel="USD" />
            <CustomPriceRange range={range} setRange={setRange} />
            <CustomHierarchicalMenu
              attributes={[
                'categories.lvl0',
                'categories.lvl1',
                'categories.lvl2'
              ]}
              limit={7}
              label="Category"
              showMore={true}
              onShowMore={setIsShowMore}
            />
            <CustomClearRefinements setRange={setRange} />
          </>
        }
        content={
          <>
            <CustomSearchBox keyword={suggestion} setSuggestion={setSuggestion} />
            <CustomBreadcrumb
              attributes={[
                'categories.lvl0',
                'categories.lvl1',
                'categories.lvl2'
              ]}
            />
            <CustomInfiniteHits
              loading={loading}
              order={order}
              full_order={full_order}
              onAddItem={onAddItem}
              onDeleteItem={onDeleteItem}
              divisions={divisions}
              size={size}
              sidebarMinWidth={SIDEBAR_MIN_WIDTH}
              range={range}
              isProductsPage={isProductsPage}
            />
          </>
        }
      />
      <Configure userToken={!productSuggestionsDisabled ? userToken : undefined} hitsPerPage={itemsPerPage} clickAnalytics={!productSuggestionsDisabled} />
    </InstantSearch >
  );
};

export default ProductSuggestionSearch;
